import { FC } from 'react'
import { Button, Drawer, Grid, TextField, Typography } from '@mui/material'
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import EditAttributesIcon from '@mui/icons-material/EditAttributes';
import CloseIcon from '@mui/icons-material/Close';

const SearcherKFCFilterModal: FC<any> = (props): JSX.Element | any => {
    const { open, close } = props
    return (
        <Drawer anchor="left" open={open} onClose={close} ModalProps={{ keepMounted: true }} PaperProps={{ sx: { width: 500 } }}>
            <Grid container width='80%' display='flex' margin='auto' >
                <Grid item container display='flex' justifyContent='end'>
                    <Button onClick={close}>
                        <CloseIcon />
                    </Button>
                </Grid>
                <Grid item container display='flex' justifyContent='center'>
                    <Typography variant='h5'>Filtros avanzados:</Typography>
                </Grid>
                <Grid item container sx={{ mt: 3, mb: 3 }}>
                    <Grid item container>
                        <RecentActorsIcon sx={{ color: '#858484', mr: 1 }} />
                        <Typography>Código:</Typography>
                    </Grid>
                    <Grid item container>
                        <TextField id="outlined-basic" variant="outlined" size='small' fullWidth />
                    </Grid>
                </Grid>
                <Grid item container sx={{ mb: 3 }}>
                    <Grid item container>
                        <CategoryIcon sx={{ color: '#858484', mr: 1 }} />
                        <Typography>Categoría:</Typography>
                    </Grid>
                    <Grid item container>
                        <TextField id="outlined-basic" variant="outlined" size='small' fullWidth />
                    </Grid>
                </Grid>
                <Grid item container sx={{ mb: 3 }}>
                    <Grid item container>
                        <AccountTreeIcon sx={{ color: '#858484', mr: 1 }} />
                        <Typography>Subcategoría:</Typography>
                    </Grid>
                    <Grid item container>
                        <TextField id="outlined-basic" variant="outlined" size='small' fullWidth />
                    </Grid>
                </Grid>
                <Grid item container sx={{ mb: 3 }}>
                    <Grid item container>
                        <EditAttributesIcon sx={{ color: '#858484', mr: 1 }} />
                        <Typography>Atributo específico:</Typography>
                    </Grid>
                    <Grid item container>
                        <TextField id="outlined-basic" variant="outlined" size='small' fullWidth />
                    </Grid>
                </Grid>
                <Grid item container sx={{ mb: 3 }}>
                    <Grid item container>
                        <EditAttributesIcon sx={{ color: '#858484', mr: 1 }} />
                        <Typography>Atributo de uso:</Typography>
                    </Grid>
                    <Grid item container>
                        <TextField id="outlined-basic" variant="outlined" size='small' fullWidth />
                    </Grid>
                </Grid>
            </Grid>
        </Drawer>
    )
}

export default SearcherKFCFilterModal